import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import { FlexWrap } from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import React, { useEffect, useState } from 'react'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertionNew'
import { RowNumberDriveAlignCenter } from '../../../../../../components/TableStyles/TableContentStyles/TableContentStyles'
import { EmptyElement } from '../../../../../../components/UIComponents/CommonStyledDiv'
import CandidateViewDrawer from '../../../ApplicantTrackingSystem/ApplicationTable/Partials/CandidateViewDrawer'
import {
  RowNumberData,
  RowNumberDataTitle,
  RowNumberDataYr,
} from '../IndividualPage/Partials/CandidateTable/style'
import {
  AlertTextDivNew,
  NoteMessageDivNew,
  StyledSpaceDiv,
} from '../OverViewpage/style'
import { CardsFlexNew } from '../Style/style'
import CandidateResumeView from './Partials/CandidateResume'
import QuestionnierFilter from './Partials/QuestionnierDBFilter'

const QuestionaireTable = ({
  questionaireDBList,
  setContent,
  content,
  questionnaireData,
  selectedRound,
  onPageChange,
  singleRoleData,
  pageLimit,
  pageNum,
  handleSort,
  searchValue,
  candidateFilterData,
  setCandidateFilterData,
  setSearchValue,
  loading,

  getCandidateDetails,
  getPromotion,

  setFilterStatus,

  qbBasedCollegeList,
  qbsBasedDegreeList,
  setCheckedIds,
  checkedIds,
  setSelectedRowKeys,
  selectedRowKeys,
  getQuestionAndAnswerList,
  roleId,
  onClickShortlist,
  setDrawerStatus,
  drawerStatus,
  setSelectedId,
  setViewDrawer,
  viewDrawer,
  setText,
  text,
  setCountDrive,
  countDrive,
  college,
  setCollege,
}) => {
  useEffect(() => {
    if (questionaireDBList) {
      const newCount = questionaireDBList?.result?.reduce((acc, item) => {
        if (item?.driveRoleCandidateMap?.length > 0) {
          return acc + 1
        }
        return acc
      }, 0)

      setCountDrive(questionaireDBList?.result?.length - newCount)
    }
  }, [questionaireDBList])

  const [checkedKeys, setCheckedKeys] = useState([])
  const [rolesDegreeList, setRolesDegreeList] = useState([])
  const [questions, setQuestions] = useState([])
  const convertedAtsBasedDegreeList = qbsBasedDegreeList?.map(item => ({
    degree: item?.currentCourse?.degree,
    degreeId: item?.currentCourse?.degreeId,
    degreeStreamMapIds: item?.currentCourse?.degreeStreamMapIds,
  }))

  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: convertedAtsBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'degreeStreamMapIds',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [qbsBasedDegreeList])

  const [candidateLoading, setCandidateLoading] = useState(false)
  const [candidateRating, setCandidateRating] = useState({
    minValue: 0,
    maxValue: 5,
  })

  const [yearOfExperience, setYearOfExperience] = useState({
    minValue: 0,
    maxValue: Math.ceil(questionnaireData?.maxWorkExperience),
  })

  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId,
      setLoading: setCandidateLoading,
    })

    if (status >= 200 && status < 300) {
      setViewDrawer(true)
    }
  }

  const pastCourseDetails = student => {
    const formatEducation = education =>
      `${education?.degree?.toLowerCase()} - ${education?.department?.toLowerCase()}`

    if (student?.isExpCandidate) {
      return student?.educationProfile?.map(formatEducation)
    } else {
      const { currentCourse } = student || {}
      const degree =
        currentCourse?.shortForm || currentCourse?.degree?.toLowerCase()
      const department = currentCourse?.department?.toLowerCase()
      return `${degree} - ${department}`
    }
  }

  const columns = [
    singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
      ? {
          title: 'candidate Name',
          dataIndex: 'firstName',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          render: (_, { student, isApplied }) => (
            <CandidateResumeView
              key={student?.id}
              student={student}
              candidateLoading={candidateLoading}
              getPromotion={getPromotion}
              studentDetailsAPI={studentDetailsAPI}
              status={isApplied}
              setDrawerStatus={setDrawerStatus}
              setSelectedId={setSelectedId}
              questionAndAnswer={questionAndAnswer}
            />
          ),
        }
      : {
          title: (
            <CardsFlexNew column>
              <RowNumberDataTitle>{'CANDIDATE NAME'}</RowNumberDataTitle>
              <RowNumberDataTitle>{'PHONE NUMBER'}</RowNumberDataTitle>
            </CardsFlexNew>
          ),
          dataIndex: 'firstName',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          render: (_, { student, isApplied }) => (
            <CandidateResumeView
              key={student?.id}
              student={student}
              candidateLoading={candidateLoading}
              getPromotion={getPromotion}
              studentDetailsAPI={studentDetailsAPI}
              status={isApplied}
              setDrawerStatus={setDrawerStatus}
              setSelectedId={setSelectedId}
              questionAndAnswer={questionAndAnswer}
            />
          ),
        },
    singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
      ? {
          title: 'College Name',
          dataIndex: 'instituteCampusName',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          render: (_, { student }) => (
            <FlexWrap alignCenter gap="8px">
              <RowNumberData>
                {student?.instituteCampusName ? (
                  student.instituteCampusName
                ) : (
                  <span
                    style={{
                      display: 'inline-block',
                      textAlign: 'center',
                      width: '100%',
                    }}
                  >
                    -
                  </span>
                )}
              </RowNumberData>
            </FlexWrap>
          ),
        }
      : {
          title: (
            <CardsFlexNew column>
              <RowNumberDataTitle>{'LATEST COMPANY'}</RowNumberDataTitle>
              <RowNumberDataTitle>{'LATEST ROLE'}</RowNumberDataTitle>
            </CardsFlexNew>
          ),

          render: (_, { student }) => (
            <CardsFlexNew column>
              <RowNumberData>{student?.latestCompany}</RowNumberData>
              <RowNumberData>{student?.latestRole}</RowNumberData>
            </CardsFlexNew>
          ),
        },
    singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
      ? {
          title: 'Location',
          dataIndex: 'instituteCampusLocation',
          sorter: false,
          render: (_, { student }) => (
            <RowNumberData>{student?.instituteCampusLocation}</RowNumberData>
          ),
        }
      : {
          title: 'Total Experience',
          dataIndex: 'experience',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          render: (_, { student }) => {
            const { workExperience } = student

            const totalMonths = Math.round(workExperience * 12)
            const years = Math.floor(totalMonths / 12)
            const months = totalMonths % 12

            const experienceParts = []
            if (years > 0) {
              experienceParts.push(`${years} yr${years > 1 ? 's' : ''}`)
            }
            if (months > 0) {
              experienceParts.push(`${months} mo${months > 1 ? 's' : ''}`)
            }
            return (
              <RowNumberDataYr style={{ paddingLeft: '10px' }}>
                {experienceParts.join(' ')} {}
              </RowNumberDataYr>
            )
          },
        },
    singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
      ? {
          width: '22%',
          title: 'DEG & Department',
          dataIndex: 'degree',
          sorter: true,
          key: 'degree',
          sortDirections: ['ascend', 'descend'],
          render: (_, { student }) => (
            <RowNumberData>{pastCourseDetails(student)}</RowNumberData>
          ),
        }
      : {
          title: 'Current Location',
          dataIndex: 'corrCity',
          sorter: true,
          render: (_, { student }) => (
            <RowNumberData style={{ paddingLeft: '10px' }}>
              {student?.studentPersonalProfile?.corrCity}
            </RowNumberData>
          ),
        },
    // {
    //   title: <div style={{ textAlign: 'center' }}>Candidate Rating</div>,
    //   dataIndex: 'rating',
    //   sorter: true,
    //   sortDirections: ['ascend', 'descend'],
    //   render: rating => (
    //     <FlexWrap
    //       gap="5px"
    //       style={{
    //         display: 'flex',
    //         flexDirection: 'row',
    //         justifyContent: 'center',
    //         width: '100%',
    //       }}
    //     >
    //       <RowNumberDriveAlignCenter>
    //         {Number(rating)?.toFixed(2)}
    //       </RowNumberDriveAlignCenter>
    //       <AntdAvatar
    //         size={22}
    //         IconName={<GreenStarIcon />}
    //         background="none"
    //       />
    //     </FlexWrap>
    //   ),
    // },
  ]

  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys)
    if (countDrive == selectedRowKeys?.length) {
      setContent(false)
      setText(false)
    } else setContent(true)
    setText(false)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => {
      return {
        disabled: record?.driveRoleCandidateMap?.length > 0,
      }
    },
    renderCell: (checked, record, index, originNode) => {
      return record?.driveRoleCandidateMap?.length > 0 ? (
        <Tooltip title="Drive is scheduled">{originNode}</Tooltip>
      ) : (
        originNode
      )
    },
  }

  const questionAndAnswer = async id => {
    let studentId = id
    const { status, data } = await getQuestionAndAnswerList({
      roleId,
      studentId,
    })
    if (status >= 200 && status < 300) {
      setQuestions(data?.data || [])
    }
  }

  const handleSelectAllClick = () => {
    setText(true)
  }

  const handleClearAllClick = () => {
    setText(false)
    setSelectedRowKeys([])
  }

  return (
    <>
      {questionaireDBList?.totalCount == 0 ? (
        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
          At present, there have been no applicants for this role
        </div>
      ) : (
        <>
          {!content &&
          selectedRowKeys?.length > 0 &&
          selectedRound == 'Rejected Candidates' &&
          questionaireDBList?.count > 10 &&
          !text ? (
            <div style={{ display: 'flex', wordSpacing: '2px' }}>
              <div style={{ fontSize: '13px', paddingTop: '10px' }}>
                {}
                {`Selected `}
                <span style={{ fontWeight: 800 }}>
                  {`${selectedRowKeys?.length} ${
                    selectedRowKeys?.length > 1 ? 'candidates' : 'candidate'
                  }`}
                </span>
                {` from this page.`}
              </div>
              <NoteMessageDivNew mandatory={true}>
                <StyledSpaceDiv mandatory={true}>
                  <AlertTextDivNew mandatory={true}>
                    <span>
                      <EmptyElement
                        style={{
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                        }}
                        onClick={handleSelectAllClick}
                      >
                        {`Select all `}
                        <span style={{ fontWeight: 800 }}>
                          {`${questionaireDBList?.count} ${
                            questionaireDBList?.count > 1
                              ? 'candidates'
                              : 'candidate'
                          }`}
                        </span>
                        {` from all pages.`}
                      </EmptyElement>
                    </span>
                  </AlertTextDivNew>
                </StyledSpaceDiv>
              </NoteMessageDivNew>
            </div>
          ) : !content &&
            selectedRowKeys?.length > 0 &&
            selectedRound == 'Rejected Candidates' &&
            questionaireDBList?.count > 10 &&
            text ? (
            <div style={{ display: 'flex', wordSpacing: '2px' }}>
              <div style={{ fontSize: '13px', paddingTop: '10px' }}>
                {`Selected all `}
                <span style={{ fontWeight: 800 }}>
                  {`${questionaireDBList?.count}`}
                  {` candidates `}
                </span>
                {`from all pages.`}
              </div>
              <NoteMessageDivNew mandatory={true}>
                <StyledSpaceDiv mandatory={true}>
                  <AlertTextDivNew mandatory={true}>
                    <span>
                      <EmptyElement
                        style={{
                          fontWeight: '800',
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                        }}
                        onClick={handleClearAllClick}
                      >
                        {`Clear Selection`}
                      </EmptyElement>
                    </span>
                  </AlertTextDivNew>
                </StyledSpaceDiv>
              </NoteMessageDivNew>
            </div>
          ) : (
            ''
          )}
          {!content &&
          selectedRowKeys?.length > 0 &&
          selectedRound == 'Shortlisted Candidates' &&
          questionaireDBList?.count > 10 &&
          !text ? (
            <div style={{ display: 'flex', wordSpacing: '2px' }}>
              <div style={{ fontSize: '13px', paddingTop: '10px' }}>
                {}
                Selected{' '}
                <span style={{ fontWeight: 800 }}>
                  {selectedRowKeys?.length}{' '}
                  {selectedRowKeys?.length > 1 ? 'candidates' : 'candidate'}
                </span>{' '}
                without scheduled drive from this page.
              </div>
              <NoteMessageDivNew mandatory={true}>
                <StyledSpaceDiv mandatory={true}>
                  <AlertTextDivNew mandatory={true}>
                    <span>
                      <EmptyElement
                        style={{
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                        }}
                        onClick={handleSelectAllClick}
                      >
                        Select all{' '}
                        <span style={{ fontWeight: 800 }}>
                          {`${questionaireDBList?.driveCountForFilter} ${
                            questionaireDBList?.driveCountForFilter > 1
                              ? 'candidates'
                              : 'candidate'
                          }`}
                        </span>{' '}
                        without scheduled drive from all pages.
                      </EmptyElement>
                    </span>
                  </AlertTextDivNew>
                </StyledSpaceDiv>
              </NoteMessageDivNew>
            </div>
          ) : !content &&
            selectedRowKeys?.length > 0 &&
            selectedRound == 'Shortlisted Candidates' &&
            questionaireDBList?.count > 10 &&
            text ? (
            <div style={{ display: 'flex', wordSpacing: '2px' }}>
              <div style={{ fontSize: '13px', paddingTop: '10px' }}>
                {`Selected all `}
                <span style={{ fontWeight: 800 }}>
                  {`${questionaireDBList?.driveCountForFilter}`} candidates
                </span>
                {` without scheduled drive from all pages.`}
              </div>

              <NoteMessageDivNew mandatory={true}>
                <StyledSpaceDiv mandatory={true}>
                  <AlertTextDivNew mandatory={true}>
                    <span>
                      <EmptyElement
                        style={{
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          wordSpacing: '2px',
                          cursor: 'pointer',
                          fontWeight: 800,
                        }}
                        onClick={handleClearAllClick}
                      >
                        {`Clear Selection`}
                      </EmptyElement>
                    </span>
                  </AlertTextDivNew>
                </StyledSpaceDiv>
              </NoteMessageDivNew>
            </div>
          ) : (
            ''
          )}

          <QuestionnierFilter
            questionaireDBList={questionaireDBList}
            questionnaireData={questionnaireData}
            singleRoleData={singleRoleData}
            setSearchValue={setSearchValue}
            candidateFilterData={candidateFilterData}
            setCandidateFilterData={setCandidateFilterData}
            searchValue={searchValue}
            candidateRating={candidateRating}
            setCandidateRating={setCandidateRating}
            setYearOfExperience={setYearOfExperience}
            yearOfExperience={yearOfExperience}
            checkedKeys={checkedKeys}
            setCheckedKeys={setCheckedKeys}
            checkedIds={checkedIds}
            setCheckedIds={setCheckedIds}
            setFilterStatus={setFilterStatus}
            qbBasedCollegeList={qbBasedCollegeList}
            rolesDegreeList={rolesDegreeList}
            college={college}
            setCollege={setCollege}
          />
          <StyledTable
            loading={loading}
            columns={columns}
            pagination={false}
            dataSource={questionaireDBList?.result}
            rowKey={student => student?.student?.id}
            onChange={handleSort}
            {...(selectedRound !== 'Applied Candidates' && {
              rowSelection: rowSelection,
            })}
          />
          {questionaireDBList?.count > 0 && (
            <Pagination
              onChange={onPageChange}
              totalPages={questionaireDBList?.totalPage * 10}
              pageSize={pageLimit}
              current={pageNum || pageNum + 1}
            />
          )}
          <CandidateViewDrawer
            candidateDrawer={viewDrawer}
            setCandidateDrawer={setViewDrawer}
            singleRoleData={singleRoleData}
            questionnaire={true}
            drawerStatus={drawerStatus}
            buttonText={
              drawerStatus == -1
                ? 'Shortlist this Candidate'
                : 'Reject this Candidate'
            }
            onClickShortlist={onClickShortlist}
            questions={questions}
          />
        </>
      )}
    </>
  )
}

export default QuestionaireTable
